<template>
  <div class="company-edit">
    <modal
      title=""
      class="edit-company-modal"
      :open="isOpen"
      @save="save()"
      @cancel="cancel()"
    >
      <field
        v-model="workingCompany.name"
        type="text"
        class="field"
        required
        name="name"
        :label="$t('ui.company.fields.name')"
        :autofocus="true"
      />
      <field
        v-model="workingCompany.website"
        type="text"
        class="field"
        name="website"
        :label="$t('ui.company.fields.website')"
      />
      <div class="flex">
        <field
          v-model="workingCompany.address.street"
          type="text"
          class="field"
          name="street"
          :label="$t('ui.company.fields.street')"
        />
        <field
          v-model="workingCompany.address.street_number"
          type="text"
          class="field"
          name="number"
          :label="$t('ui.company.fields.street_number')"
        />
      </div>
      <div class="flex">
        <field
          v-model="workingCompany.address.city"
          type="text"
          class="field"
          name="city"
          :label="$t('ui.company.fields.city')"
        />
        <field
          v-model="workingCompany.address.zip"
          type="text"
          class="field"
          name="zip"
          :label="$t('ui.company.fields.postcode')"
        />
      </div>
      <country-select
        :value="workingCountry"
        type="text"
        @input="setCountry($event)"
        :params="{ favorites: ['DE'] }"
        class="field"
        name="country"
        :label="$t('ui.company.fields.country')"
      />
    </modal>
  </div>
</template>

<script>
import Modal from "@/components/helpers/Layout/NewModal.vue";
import Field from "@/components/helpers/DataInput/Field";
import CountrySelect from "@/components/helpers/DataInput/CountrySelect.vue";

export default {
  components: { Field, CountrySelect, Modal },
  props: {
    company: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      workingCompany: {},
      workingCountry: ""
    };
  },
  beforeMount() {
    this.init();
  },
  watch: {
    isOpen: function() {
      return this.init();
    }
  },
  methods: {
    init() {
      this.workingCompany = _.cloneDeep(this.company);
      if (!this.workingCompany.address) {
        this.workingCompany.address = {};
      }
      this.workingCountry = _.get(
        this.workingCompany,
        "address.country",
        ""
      ).toUpperCase();
    },
    setCountry(val) {
      this.workingCountry = val;
    },
    save() {
      this.workingCompany.address.country = this.workingCountry;
      this.$emit("save", this.workingCompany);
    },
    cancel() {
      this.$emit("cancel");
    }
  }
};
</script>

<style lang="sass">
@media (max-width: 575px)
  .edit-company-modal
    max-height: 500px !important
    .modal-wrapper
      min-width: 100%
      width: 320px
    .modal-component
      padding: 1em 0 !important
      text-align: center !important

.company-edit
  .modal-component
    max-height: 600px
</style>



// WEBPACK FOOTER //
// CompanyEdit.vue?ca3b2ed2